import GameClientHubConnection = GameClientHub.GameClientHubConnection;
import { UriHelper } from "neo-common";
import { AppContext } from "../../Common/AppContext";

export class WebSocketClient {
    private hubConnection: GameClientHubConnection;
    private connected: boolean;

    constructor() {
        this.connected = false;

        const urlInfo: Object = UriHelper.parseUrl(window.location.href, true, true);
        if (urlInfo != null && urlInfo["query"]["serverUrl"] && urlInfo["hash"]) {
            let serverUrl: string = urlInfo["query"]["serverUrl"];

            try {
                this.hubConnection = new GameClientHub.GameClientHubConnection(
                    serverUrl,
                    this.getToken,
                    AppContext.gameConfiguration,
                );
                this.connected = true;
            } catch (e) {
                if (DEBUG) {
                    console.log("ERROR websocket connection was not created: " + e);
                }
            }
        }
    }

    private getToken(): string {
        let token = "";

        const urlInfo: Object = UriHelper.parseUrl(window.location.href, true, true);
        if (urlInfo != null && urlInfo["hash"]) {
            token = urlInfo["hash"].substring(1).split("=")[1];
        }

        return token;
    }

    public sendMessage(methodName: string, data: any): void {
        if (this.hubConnection != null && this.connected) {
            this.hubConnection.sendMessage(methodName, data);
        }
    }

    public on(methodName: string, callbackFn: (message: string) => void): void {
        if (this.hubConnection != null) {
            this.hubConnection.on(methodName, callbackFn);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Utils/WebSocketClient.ts
 **/